<template>
  <div class="confirm-dialog">
    <div class="confirm-dialog-overlay" v-if="showOverlay"></div>
    <div class="confirm-dialog-content" :style="{ maxWidth: maxWidthOption }">
      <h2 class="confirm-dialog-title">{{ title === "" ? "UBIST" : title }}</h2>
      <p class="confirm-dialog-message">{{ message }}</p>
      <div class="confirm-dialog-actions">
        <button class="confirm-dialog-confirm" @click="handleConfirm">
          {{ $t("button.confirm") }}
        </button>
        <button class="confirm-dialog-cancel" @click="handleCancel">
          {{ $t("button.cancel") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmDialog",
  props: {
    maxWidthOption: {
      type: String,
      default: "500px",
    },
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    data1: {
      required: false,
    },
    data2: {
      required: false,
    },
  },
  computed: {
    showOverlay() {
      return this.$slots.default !== undefined;
    },
  },
  methods: {
    handleConfirm() {
      this.$emit("confirmed", this.data1, this.data2, true);
    },
    handleCancel() {
      this.$emit("confirmed", this.data1, this.data2, false);
    },
  },
};
</script>

<style scoped>
.confirm-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.confirm-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.confirm-dialog-content {
  background-color: #fff;
  padding: 20px;
  max-width: 500px;
  width: 100%;
  border-radius: 4px;
  box-shadow: 0 12px 24px 4px rgba(0, 0, 0, 0.25); /* 20230622 수정 */
}

.confirm-dialog-title {
  font-size: 22px; /* 20230622 수정 */
  font-weight: 700; /* 20230622 수정 */
  margin-bottom: 10px;
}

.confirm-dialog-message {
  font-size: 15px; /* 20230622 수정 */
  line-height: 1.5; /* 20230622 수정 */
  margin-bottom: 20px;
}

.confirm-dialog-actions {
  text-align: right;
}

.confirm-dialog-confirm,
.confirm-dialog-cancel {
  padding: 10px 20px;
  font-size: 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.confirm-dialog-confirm {
  background-color: var(--primary-color); /* 20230622 수정 */
  color: #fff;
  margin-right: 10px;
}

.confirm-dialog-cancel {
  background-color: #e0e0e0;
}
</style>
